/**
 * Возвращает дату истечения срока действия
 * @param {number} expiresAfterS - время истечения в секундах
 */
export const getExpires = (expiresAfterS) => {
  return new Date(Date.now() + expiresAfterS * 1000)
}
